
import defaultNavigation2 from "../menu-items";
import patientNavigation from "../patient-menu-items";
import profileNavigation from "../profile-menu-items";
import employeeNavigation from "../employee-menu-items";

const defaultNavigation = {
    items :[
        {
            id: 'loading',
            title: 'Loading...',
            type: 'group',
            icon: 'fa fa-spinner',
            color: 'brown',
        }
    ]
}

export const getNavigation = (location={pathname:'/'})=>{
    console.log("nav",location);
    const firstPath = location.pathname.split('/')[1];
    const navMap = {"patient":patientNavigation,"users":profileNavigation,"employee":employeeNavigation,"default":defaultNavigation};

    if(["stock","settings","ecommerce","menu"].includes(firstPath)){
        let nav = defaultNavigation.items.find(item => item.id==firstPath)
        if(nav){
            nav = Object.assign(nav,{backIcon :'fa fa-chevron-left',  backUrl : '/'})
            return {items:[nav]};
        }
    }else{
        navMap["default"].items = defaultNavigation.items.map((item,index)=>{
            delete item.backIcon;
            delete item.backUrl
            return item
        })
    }
    
    return navMap[firstPath]?navMap[firstPath]:navMap["default"];
}

const navigation = getNavigation()

export default navigation;
